import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { closeAboutMIniMap } from 'widgets/map.corner/model/actions';
import { CornerMap } from 'features/map.corner/ui';
import { Alert, Snackbar } from '@mui/material';
import { select_ui_settings } from 'console/redux/settings-actions';
import { createSelector } from '@reduxjs/toolkit';
import { memo_loc_info } from 'entities/device.map.track/lib/memo-loc-info';
import { selectDevicesFields } from 'entities/device/lib';
import { select_map_center_per_device } from 'shared/map/model/selectors';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { memo } from 'react';
const anchorOrigin = { vertical: 'bottom', horizontal: 'center' };
const getMiniMapDevices = createSelector((state) => state.mini_map.map, selectDevicesFields([
    'id',
    'last_gps',
    'color',
    'name',
    'iconState',
    'individual_device_name',
]), (map_items, devices) => devices.filter((dev) => map_items.some((el) => el.device_id == dev.id)));
export const MiniMaps = memo(function MiniMaps() {
    const requested_devices = useAppSelector((state) => state.mini_map.map);
    if (requested_devices.length == 0) {
        return null;
    }
    return _jsx(MiniMapsImpl, {});
});
export const MiniMapsImpl = memo(function MiniMapsImpl() {
    const onClickCloseAboutMiniMap = useAction(closeAboutMIniMap);
    const mini_map_open = useAppSelector((state) => state.mini_map.open_mini_map);
    const devices = useAppSelector(getMiniMapDevices);
    const markers_info = memo_loc_info(devices);
    const provider = useAppSelector((state) => state.ui_settings.map?.provider ?? 'yandex');
    const centers = useAppSelector(select_map_center_per_device);
    const marker_size = useAppSelector((state) => select_ui_settings(state).map?.marker_size ?? 32);
    return (_jsxs(ErrorBoundary, { children: [markers_info.map((el, index) => (_jsx(CornerMap, { device_id: el.id, markers_info: el, provider: provider, center: centers[el.id] ?? [55, 56.3], marker_size: marker_size }, el.id - index))), _jsx(Snackbar, { autoHideDuration: 2000, open: mini_map_open, onClose: onClickCloseAboutMiniMap, anchorOrigin: anchorOrigin, children: _jsx(Alert, { elevation: 6, variant: "filled", severity: "warning", children: "\u041A\u0430\u0440\u0442\u0430 \u043E\u0442\u043A\u0440\u044B\u0442\u0430 \u043D\u0430 \u044D\u0442\u043E\u043C \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0435!" }) })] }));
});
